import Cookies from "js-cookie";
import { Outlet ,Navigate} from "react-router-dom";

const ProtectedRoutes = () => {
    return Cookies.get("iran_admin_token") ? <Outlet /> : <Navigate to={'/login'} />
}
 
export default ProtectedRoutes;